import { render } from "./HomeGameProviders.vue?vue&type=template&id=7d1c3e6c&scoped=true&ts=true"
import script from "./HomeGameProviders.vue?vue&type=script&lang=ts"
export * from "./HomeGameProviders.vue?vue&type=script&lang=ts"

import "./HomeGameProviders.vue?vue&type=style&index=0&id=7d1c3e6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1c3e6c"]])

export default __exports__